import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import { addUser, emptyCart } from '../../store/actions/action';

const Logout = ({ children, className, onClick, ...props }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector((store) => store);

  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      
      // Clear user data from Redux store
      dispatch(addUser([]));
      dispatch(emptyCart());
      
      // // Show success message
      // toast.success(
      //   `${user.user?.email || 'User'} successfully logged out!`
      // );
      
      // Redirect to home page
      history.push('/');
      
      // Call any additional onClick handler if provided
      if (onClick) {
        onClick();
      }
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Error during logout: ' + error.message);
    }
  };

  return (
    <button
      className={className}
      onClick={handleLogout}
      {...props}
    >
      {children}
    </button>
  );
};

export default Logout;